var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdvancedLevelOnboarding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#1CC67C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6492 22.5301C26.4453 22.5301 25.4692 21.5539 25.4692 20.35C25.4692 19.1461 26.4453 18.1699 27.6492 18.1699C28.8532 18.1699 29.8292 19.1461 29.8292 20.35C29.8292 21.5539 28.8532 22.5301 27.6492 22.5301ZM27.6492 18.9628C26.8862 18.9628 26.2619 19.5869 26.2619 20.35C26.2619 21.1131 26.8862 21.7372 27.6492 21.7372C28.4122 21.7372 29.0365 21.1131 29.0365 20.35C29.0365 19.5869 28.4122 18.9628 27.6492 18.9628Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8794 27.5586L20.44 28.1192L16.793 31.7662L16.2324 31.2056L19.8794 27.5586Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6893 25.9746L19.2499 26.535L16.7904 28.9945L16.23 28.434L18.6893 25.9746Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4639 28.75L22.0243 29.3106L19.565 31.7699L19.0044 31.2093L21.4639 28.75Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0728 32.9992V27.8266H25.8654V31.0868L28.6401 28.3122V25.2354H29.4328V28.6392L25.0728 32.9992Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1726 22.9274H15L19.36 18.5674H22.7589V19.3601H19.687L16.9124 22.1347H20.1726V22.9274Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9472 28.8927L19.1074 25.0529L19.1321 24.8596C19.8357 19.2411 25.6276 15 32.6037 15H33V15.3964C33 22.3625 28.7638 28.1545 23.1404 28.8679L22.9472 28.8927ZM19.9447 24.7655L23.2346 28.0553C28.2585 27.3023 32.0488 22.1049 32.2073 15.7976C25.8853 15.9513 20.6928 19.7416 19.9447 24.7655Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvancedLevelOnboarding);
export default __webpack_public_path__ + "static/media/advanced_level_onboarding.b56cf16e.svg";
export { ForwardRef as ReactComponent };